import axios from 'axios';

export const http = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
});

export async function authHeaders(getToken) {
    const token = await getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
}